import React, {useState} from "react";
import {prompts} from "../prompts/money";


export default function CardPrompter({prompts, bgColour}) {

    const [displayedPrompts, setDisplayedPrompts] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(-1);

    // Function to handle the "Next" button click
    const handleNext = () => {
        if (displayedPrompts.length === prompts.length) {
            // If all prompts have been displayed, start over
            alert("You've seen all the prompts! Starting over.");
            setDisplayedPrompts([]);
            setCurrentIndex(-1);
            return;
        }

        let nextPrompt;
        do {
            // Choose a random prompt that hasn't been displayed yet
            nextPrompt = prompts[Math.floor(Math.random() * prompts.length)];
        } while (displayedPrompts.includes(nextPrompt));

        // Update the displayed prompts and current index
        setDisplayedPrompts([...displayedPrompts, nextPrompt]);
        setCurrentIndex(displayedPrompts.length);
    };

    // Function to handle the "Previous" button click
    const handlePrevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    return (
        <div className="mx-auto max-w-3xl px-4 py-8 sm:px-6 lg:px-8">
            {/* Card prompt */}
            <div className={`min-h-80 mx-auto overflow-hidden rounded-lg shadow ${bgColour} max-w-xl`}>
                <div
                    className="flex flex-col justify-center items-center min-h-80 px-6 py-10 text-balance text-2xl font-semibold text-white sm:text-5xl text-center">
                    {currentIndex >= 0 ? displayedPrompts[currentIndex] : "Click 'Next' to see a prompt"}
                </div>
            </div>

            {/* Navigation Buttons */}
            <div className="mx-auto flex justify-between mt-4 max-w-xl">
                <button
                    onClick={handlePrevious}
                    disabled={currentIndex <= 0}
                    className={`relative inline-flex items-center justify-center rounded-md min-w-32
                            bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0 ${
                        currentIndex > 0 ? "" : "cursor-not-allowed"
                    }`}

                >
                    Previous
                </button>
                <button
                    onClick={handleNext}
                    className="relative inline-flex justify-center items-center rounded-md min-w-32
                            bg-gray-900 px-3 py-2 text-sm font-semibold text-white
                            ring-1 ring-inset ring-gray-300 hover:bg-gray-500 focus-visible:outline-offset-0"
                >
                    Next
                </button>
            </div>
        </div>
    );
}
